import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { initializeAuthStorage } from "./renderer/platform/authStorage";
import { initializeDesktopIntegration } from "./renderer/platform/desktopIntegration";
import { configureServiceWorker } from "./renderer/platform/serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApplication = () => {
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );
};

const startApplication = async () => {
  await initializeAuthStorage();
  await configureServiceWorker().catch((error) => {
    console.warn("Service worker setup was skipped", error);
  });
  await initializeDesktopIntegration().catch((error) => {
    console.error("Desktop integration could not be initialized", error);
  });

  renderApplication();
};

void startApplication().catch((error) => {
  console.error("Orderly startup failed", error);
  renderApplication();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
